<template>
    <div class="teams-container">
        <router-view :formData="{}" :updateCount="updateCount" />
    </div>
</template>
<script>
import organisationRolesMixin from '@/mixins/organisationPermissionsMixin'
export default {
    props: {
        updateCount: {
          type: Function,
          default: () => {}
      }
    },
    watch: {
        '$route' (to, from) {
            if (to.params.tid !== from.params.tid) {
                this.setTeamRolesAndPermission()
            }
        }
    },
    mixins: [organisationRolesMixin],
    beforeMount () {
        this.setTeamRolesAndPermission()
    }
}
</script>